import { insertPdf, deletePdf, getNode, setActiveTool } from "../../../commands/custom-commands";
import { customSchema, validPdfOrientations, validPdfOrientationValues } from "../../../schemas/custom-schema";

export default class PdfTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--pdf-anchor";
    this.buttonElement.dataset.action = "pdf";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title =" PDF";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "PDF";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "PDF";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div"),
      targetInputContainer = document.createElement("div"),
      targetLabel = document.createElement("label");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--pdf-anchor";
    this.urlInput = document.createElement("input");
    this.urlInput.setAttribute("placeholder", "URL");
    this.urlInput.className = "editor-input";
    //this.urlInput.required = true;
    this.urlInput.type = "text";
    
    this.orientationDropdown = document.createElement("select");
    this.orientationDropdown.className = "editor-dropdown";
    validPdfOrientations.forEach(orientation => {
      const option = document.createElement("option");
      option.value = orientation.value;
      option.textContent = orientation.label;
      this.orientationDropdown.appendChild(option);
    })

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(this.urlInput);
    this.dialogElement.appendChild(this.orientationDropdown);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const node = getNode(view.state, customSchema.nodes.pdfContainer),
      nodeAttrs = node?.attrs,
      isEnabled = insertPdf(null, null)(view.state, null);
    if(!!node) { 
      this.urlInput.value = node.attrs.src.replace(window.location.origin + "/modernismohispanico/resources/pdf-viewer/web/viewer.html?file=", "");
      this.orientationDropdown.value = node.attrs.orientation; 
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.urlInput.value = null;
      this.orientationDropdown.value = this.orientationDropdown.options[0].value;
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.buttonElement.disabled = !isEnabled;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.urlInput = null;
    this.orientationDropdown = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      const { value: src } = this.urlInput,
        { value: orientation } = this.orientationDropdown,
        isActive = getNode(this.view.state, customSchema.nodes.pdfContainer);

      if(!insertPdf(null, null)(this.view.state, null)) {
        return false;
      }

      if(isActive) {
        deletePdf(this.view.state, this.view.dispatch, this.view);
      }

      insertPdf(src, orientation)(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}
